import { Divider, Form, Progress, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import img1 from "../../assets/img/img1.png";
import img2 from "../../assets/img/img2.png";
import img3 from "../../assets/img/img3.png";
import svg7 from "../../assets/svg/svg7.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../features/fetch/fetchSlice";
import CardLoading from "../../components/CardLoading";

 
function DashboardFy() {
  const [selectId, setSelectId] = useState(null);
  const url = `api/v1/dashboard/getDashboardParams?v_year=${selectId}`;
  const urlYear = "api/v1/fiscal-years/list";
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const [fyYear, setFyYear] = useState();
  const { data, loading, dataYear } = useSelector((state) => ({
    data: state.fetch.data[url],
    loading: state.fetch.loading[url],
    dataYear: state.fetch.data[urlYear] || [],
  }));
  const { user } = useSelector((state) => state.auth);

  const svgMap = {
    img1,
    img2,
    img3,
    svg7,
  };
  const processedData = data?.items?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
    svgSub: svgMap[item?.svgSub],
  }));

  const handleValuesChange = async (value) => {
    await setSelectId(value);
    const selectedYearObj = dataYear?.find(
      (item) => item?.fiscalYear === value
    );
    await setFyYear(selectedYearObj); 
  };

  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
      })
    );
  }

  useEffect(() => {
    if (selectId) {
      fetchTableData();
    }
  }, [selectId, user]);

  useEffect(() => {
    dispatch(fetchData({ url: urlYear }));
  }, []);
  useEffect(() => {
    if (dataYear?.length > 0) {
      const today = new Date();

      const currentFY = dataYear?.find((fy) => {
        const start = new Date(fy?.startDate);
        const end = new Date(fy?.endDate);
        return today >= start && today <= end;
      });

      if (currentFY) {
        setSelectId(currentFY.fiscalYear);
        setFyYear(currentFY);
      }
    }
  }, [dataYear]);
  if (loading) return <CardLoading />;
  return (
    <div className="white_card mt-[1.5rem] flex-1 min-h-[50vh]">
      <div className="flex items-center justify-between">
        <span className="text-[#2D3E8D] font-appleAlt text-[1.5rem] font-[600]">
          Dashboard {fyYear?.code}
        </span>
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          className="lg:w-[10%] w-full"
          form={form}
        >
          <div className="w-full banner-select flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
            <span className="">Year</span>
            <Select
              className="banner-selector"
              allowClear
              style={{
                width: "100%",
              }}
              options={dataYear?.map((item) => ({
                value: item?.fiscalYear,
                label: item?.fiscalYear,
              }))}
              value={selectId}
              onChange={(value) => handleValuesChange(value)}
              placeholder="Select"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </div>
        </Form>
      </div>
      <div className="mt-[-1rem]">
        <Divider />
      </div>
      <div className="w-full px-2">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-[3.69rem]">
          {processedData &&
            processedData?.map((item, index) => (
              <div key={index} className="h-full w-full p-[.5rem]">
                <div className="flex gap-x-[2.25rem] flex-wrap">
                  <img
                    src={item?.svg}
                    alt={item?.svg}
                    className="object-contain w-10 h-10 shrink-0"
                  />
                  <div className="flex flex-col min-w-0">
                    <span className="text-[#424242] font-appleAlt text-[2.1875rem] font-[800]">
                      {item?.count}
                    </span>
                    <span className="flex items-center text-[#424242] text-[1rem] font-[400] font-appleAlt gap-x-2">
                      {item?.title}
                      <img
                        src={item?.svgSub}
                        alt={item?.svgSub}
                        className="w-4 h-4 shrink-0"
                      />
                    </span>
                  </div>
                </div>

                <div className="mt-[2.75rem]">
                  {item?.progress &&
                    item?.progress.map((detail, i) => (
                      <div
                        key={i}
                        className="flex flex-col text-[#424242] font-appleAlt text-[1rem] font-[400] mt-[1rem]"
                      >
                        <span>{detail?.titleProgress}</span>
                        <div className="w-full">
                          <Progress
                            strokeColor="#569D6E"
                            percent={detail?.percentage}
                          />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default DashboardFy;
